/**
 * The industries a client can choose, in display order. Mirrors `Industries.All` in
 * IdVerify.Core (core/Helpers/Industries.cs) verbatim - signup and the admin create/edit forms in
 * both portals use the same list. If you change one, change the other.
 */
export const INDUSTRIES = [
  'Banking',
  'Fintech',
  'Cryptocurrency',
  'Lending',
  'Insurance',
  'Real Estate',
  'Healthcare',
  'Travel',
  'E-Commerce',
  'Gaming',
  'Other',
] as const;

/**
 * Options for an industry <select>. A value saved before the list existed (free text) is kept as
 * an extra option so editing an old client does not silently change its industry.
 */
export function industryOptions(current?: string | null): string[] {
  const list: string[] = [...INDUSTRIES];
  if (current && !list.includes(current)) list.unshift(current);
  return list;
}
